import {cart as cartStore} from "@/store/Cart";
import {observer} from "mobx-react";
import {useEffect} from "react";

const CartQty = observer(() => {
  useEffect(() => {
    // reloadCart awaits a bare fetch, called fire-and-forget. A dropped connection or
    // the shopper navigating away mid-request becomes an unhandled rejection reporting
    // as "TypeError: Failed to fetch". The badge is cosmetic and the cart itself lives
    // server-side, so that specific case is not worth reporting.
    //
    // Only that case. Swallowing everything would hide a genuine failure inside
    // setCartData, which captureUnhandledRejections reports today. Re-throwing keeps
    // the original stack rather than replacing it with one rooted here.
    cartStore.reloadCart().catch((err) => {
      const message = String((err && err.message) || err);
      if (!/failed to fetch|load failed|networkerror|network connection was lost/i.test(message)) {
        throw err;
      }
    });
  }, []);

  return cartStore.itemCount ? (
    <div className="absolute -right-2 -top-2 flex h-4 w-4 items-center justify-center rounded-full bg-deep-green text-[10px] text-white">
      {cartStore.itemCount}
    </div>
  ) : (
    <></>
  );
});

export default CartQty;
